import { DotNetDayOfWeekDTO } from '@/api/base/DTOs';
import { DayOfWeek } from '@/typings';

export const adaptDotNetDayOfWeekDTOToDayOfWeek = (
  dotNetDayOfWeek: DotNetDayOfWeekDTO,
): DayOfWeek => {
  switch (dotNetDayOfWeek) {
    case DotNetDayOfWeekDTO.Sunday:
      return DayOfWeek.Sunday;
    case DotNetDayOfWeekDTO.Monday:
      return DayOfWeek.Monday;
    case DotNetDayOfWeekDTO.Tuesday:
      return DayOfWeek.Tuesday;
    case DotNetDayOfWeekDTO.Wednesday:
      return DayOfWeek.Wednesday;
    case DotNetDayOfWeekDTO.Thursday:
      return DayOfWeek.Thursday;
    case DotNetDayOfWeekDTO.Friday:
      return DayOfWeek.Friday;
    case DotNetDayOfWeekDTO.Saturday:
      return DayOfWeek.Saturday;
  }
};
